import { omit } from "lodash";

import type {
  ChatNotificationLevel,
  NotificationToggleKey,
  SpaceFormPayload,
  SpaceFormValues,
} from "../types";
import {
  buildNotificationPreferences,
  mapChatNotificationLevelToToggles,
} from "./notificationPreferences";
import {
  isChatPostType,
  isCoursePostType,
  isEventPostType,
} from "./spaceTypePredicates";

export const buildSpaceFormPayload = (
  data: SpaceFormValues,
): SpaceFormPayload => {
  const toggles: NotificationToggleKey[] = isChatPostType(data.post_type)
    ? mapChatNotificationLevelToToggles(
        data.notification_type as ChatNotificationLevel,
      )
    : (data.notification_type as NotificationToggleKey[]);

  const base = omit(data, "notification_type", "course_setting");
  const notificationPrefs = buildNotificationPreferences(toggles);
  const courseSetting = isCoursePostType(data.post_type)
    ? { course_setting: data.course_setting }
    : {};
  const isPostDisabled = isEventPostType(data.post_type)
    ? data.is_post_disabled
    : false;

  return {
    ...base,
    ...notificationPrefs,
    ...courseSetting,
    is_post_disabled: isPostDisabled,
  };
};
